import requestLogoutSuccess from '../actions/requestLogoutSuccess';
import getUserDataFailed from '../actions/getUserDataFailed';
import userDataReceived from '../actions/userDataReceived';

export default function currentUserReducer(state = false, action) {
    if (action.type === userDataReceived.type) {
        return action.payload.data;
    }
    if (action.type === getUserDataFailed.type || action.type === requestLogoutSuccess.type) {
        return {};
    }

    return state;
}
